import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FmbZabihatBookedSlotsList from "./FmbZabihatBookedSlotsList";

export default {
  list: FmbZabihatBookedSlotsList,
  icon: CalendarMonthIcon,
  label: "Zabihat Booked Slots",
  options: { label: "Zabihat Booked Slots" },
  name: "fmbZabihatBookedSlots",
};
